import React, { Component } from 'react';
import { Link } from 'react-router';
import Box from '../componentes/Box';

class IndiceProtocolo extends Component {
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            {this.props.children}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Box titulo="Protocolo - Todas as opções" minimizado={this.props.children}>
              <div className="col-md-4">
                <h4>Consultas</h4>
                <ul>
                  <li><Link to="/protocolo/consultar">Consultar Protocolo</Link></li>
                </ul>
              </div>
            </Box>
          </div>
        </div>
      </div>
    );
  }
}

export default IndiceProtocolo;


// WEBPACK FOOTER //
// ./src/modulos/protocolo/IndiceProtocolo.js